<template>
  <div v-if="isLoading">
    <skeleton-loader height="350px" />
  </div>
  <div
    v-else
    class="nxp-vacancy-card"
    @click="
      () => {
        if (!isSimilar) return;
        $router.push({
          name: 'vacancy-detail',
          params: { vacancy, isOpen, isSimilar },
        });
        trackSimilarVacancyClick(vacancy);
      }
    "
    :style="{
      '--color': color,
      '--soft-color': colorSoft,
      cursor: isSimilar ? 'pointer' : '',
    }"
  >
    <div class="nxp-vacancy-info">
      <div v-if="isSimilar" class="w-full flex flex-row gap-4 mb-8">
        <div class="nxp-featured-tag nxp-featured-tag-compatible">
          <bolt :size="13" />
          Compatível com seu perfil
        </div>
      </div>
      <h4>
        {{ title }}
      </h4>
      <small>{{
        vacancy_status !== 1
          ? vacancy_status === 3
            ? "Vaga já Finalizada"
            : "Vaga foi Congelada pela empresa"
          : ""
      }}</small>
      <div class="w-full flex flex-col gap-1 nxp-vacancy-card-location">
        <div class="w-full flex flex-col gap-1">
          <div
            v-if="vacancy.city && vacancy.state && vacancy.show_location"
            class="w-full flex flex-row gap-2 items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
            >
              <g clip-path="url(#clip0_1984_19482)">
                <path
                  d="M6.99997 13.2629C8.47557 11.9718 9.62471 10.7135 10.4474 9.48788C11.2701 8.2623 11.6814 7.1816 11.6814 6.24577C11.6814 4.88628 11.2396 3.75527 10.3559 2.85273C9.47216 1.95018 8.35353 1.49891 6.99997 1.49891C5.64642 1.49891 4.52779 1.95018 3.64408 2.85273C2.76037 3.75527 2.31852 4.88628 2.31852 6.24577C2.31852 7.1816 2.72986 8.2623 3.55255 9.48788C4.37524 10.7135 5.52438 11.9718 6.99997 13.2629ZM6.99997 14.2318C6.86206 14.2318 6.73383 14.2091 6.61527 14.1635C6.49658 14.1179 6.37622 14.0469 6.25418 13.9507C5.88212 13.633 5.41595 13.1996 4.85566 12.6503C4.29551 12.1011 3.75 11.4844 3.21913 10.8001C2.68813 10.1158 2.23757 9.38274 1.86744 8.60082C1.49732 7.81877 1.31226 7.03376 1.31226 6.24577C1.31226 4.66594 1.84164 3.31335 2.90041 2.18801C3.95931 1.06267 5.32583 0.5 6.99997 0.5C8.66121 0.5 10.0245 1.06267 11.0899 2.18801C12.1551 3.31335 12.6877 4.66594 12.6877 6.24577C12.6877 7.03376 12.4994 7.82071 12.1228 8.60663C11.7463 9.39267 11.297 10.1291 10.775 10.8158C10.2529 11.5025 9.71179 12.116 9.15164 12.6563C8.59149 13.1967 8.12531 13.6256 7.75313 13.9431C7.63289 14.0394 7.51233 14.1115 7.39145 14.1597C7.2707 14.2078 7.14021 14.2318 6.99997 14.2318ZM7.00133 7.43955C7.34772 7.43955 7.64147 7.31854 7.88259 7.07652C8.12383 6.8345 8.24445 6.5403 8.24445 6.19391C8.24445 5.84752 8.12344 5.55371 7.88142 5.31246C7.6394 5.07135 7.34514 4.95079 6.99862 4.95079C6.65223 4.95079 6.35848 5.0718 6.11736 5.31382C5.87612 5.55584 5.7555 5.85011 5.7555 6.19662C5.7555 6.54301 5.87651 6.83676 6.11853 7.07788C6.36055 7.31899 6.65481 7.43955 7.00133 7.43955Z"
                  fill="#696969"
                />
              </g>
              <defs>
                <clipPath id="clip0_1984_19482">
                  <rect
                    width="14"
                    height="14"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            <p>{{ vacancy.city }} - {{ vacancy.state }}</p>
          </div>
          <p v-if="vacancy.show_remuneration">
            <b> {{ formattedRemuneration }}</b>
          </p>
        </div>
        <p v-if="vacancy_company_name">{{ vacancy_company_name }}</p>
      </div>

      <div class="w-full flex flex-row gap-4 my-8">
        <div v-if="vacancy.show_regime" class="nxp-featured-tag">
          {{ vacancy.regime.description }}
        </div>
        <div
          v-if="isSimilar && vacancy.remote && vacancy.remote.name"
          class="nxp-featured-tag"
        >
          {{ vacancy.remote.name }}
        </div>
        <div v-if="!isSimilar && vacancy.remote" class="nxp-featured-tag">
          Remoto
        </div>
        <div v-if="vacancy.pcd" class="nxp-featured-tag nxp-featured-tag-pcd">
          Para PCD
        </div>
        <!-- <div class="nxp-featured-tag nxp-affirmative">Vaga afirmativa</div> -->
      </div>

      <div class="w-full flex flex-col gap-2">
        <div class="w-full flex flex-row gap-2 items-center nxp-created-at">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M8.43335 7.56394V4.43311C8.43335 4.31033 8.39213 4.20738 8.30968 4.12427C8.22724 4.04127 8.12513 3.99977 8.00335 3.99977C7.88146 3.99977 7.77824 4.04127 7.69368 4.12427C7.60902 4.20738 7.56668 4.31033 7.56668 4.43311V7.71777C7.56668 7.79622 7.58124 7.86666 7.61035 7.92911C7.63935 7.99155 7.67952 8.04844 7.73085 8.09977L10.0448 10.4139C10.1388 10.5079 10.2418 10.5532 10.3538 10.5498C10.4658 10.5463 10.5701 10.4963 10.6667 10.3998C10.7632 10.3032 10.8115 10.2 10.8115 10.0901C10.8115 9.98033 10.7613 9.87577 10.661 9.77644L8.43335 7.56394ZM8.00118 14.0664C7.16552 14.0664 6.37996 13.9085 5.64452 13.5928C4.90918 13.277 4.26479 12.8425 3.71135 12.2893C3.1579 11.736 2.72318 11.0911 2.40718 10.3544C2.09129 9.61788 1.93335 8.83083 1.93335 7.99327C1.93335 7.15572 2.09124 6.36822 2.40702 5.63077C2.72279 4.89333 3.15729 4.25066 3.71052 3.70277C4.26374 3.15488 4.90868 2.72294 5.64535 2.40694C6.38191 2.09105 7.16896 1.93311 8.00652 1.93311C8.84407 1.93311 9.63157 2.09233 10.369 2.41077C11.1066 2.72922 11.7481 3.16138 12.2937 3.70727C12.8392 4.25316 13.2711 4.89511 13.5893 5.63311C13.9076 6.37111 14.0667 7.15961 14.0667 7.9986C14.0667 8.83427 13.9088 9.61983 13.593 10.3553C13.2772 11.0906 12.8455 11.735 12.2978 12.2884C11.7502 12.8419 11.1071 13.2766 10.3685 13.5926C9.62996 13.9085 8.84085 14.0664 8.00118 14.0664ZM8.00802 13.1998C9.44657 13.1998 10.6716 12.6914 11.683 11.6748C12.6943 10.6581 13.2 9.43044 13.2 7.99177C13.2 6.55322 12.6943 5.32822 11.683 4.31677C10.6716 3.30544 9.44657 2.79977 8.00802 2.79977C6.56935 2.79977 5.34168 3.30544 4.32502 4.31677C3.30835 5.32822 2.80002 6.55322 2.80002 7.99177C2.80002 9.43044 3.30835 10.6581 4.32502 11.6748C5.34168 12.6914 6.56935 13.1998 8.00802 13.1998Z"
              fill="#696969"
            />
          </svg>
          <p v-if="isOpen && vacancy_published_at">
            Publicada em {{ vacancy_published_at }}
          </p>
          <p v-else-if="!isOpen && talent_applicated_at">
            Candidatura realizada {{ talent_applicated_at }}
          </p>
        </div>

        <!-- <p class="nxp-until-date">Envie seu currículo até 05/12/2024</p> -->
      </div>
    </div>
    <div class="vacancy-card--actions">
      <button
        v-if="showPreInterviewButton && hasPreInterview"
        class="nxp-card-button-vacancy company"
        :style="{
          '--color': color,
          '--soft-color': colorSoft,
        }"
        @click="
          () => {
            if (isSimilar) return;
            $router.push({
              name: 'pre-interview',
              params: { vacancyId: vacancy.id },
            });
          }
        "
      >
        {{
          preInterviewWasStartedButNotFinished
            ? "Continuar pré-entrevista"
            : "Fazer pré-entrevista"
        }}
      </button>
      <!-- Temp disable to test openAI budget reduce -->
      <!-- <button
        @click="handleTrainForInterview"
        v-if="displayUnsubscribe && (talent_withdrawal === null) && vacancy_status === 1"
        class="nxp-card-button-vacancy company"
      >
          Treinar para Entrevista 
      </button>  -->
      <button
        @click="
          () => {
            if (isSimilar) return;
            $router.push({
              name: 'vacancy-detail',
              params: { vacancy, isOpen, isSimilar },
            });
          }
        "
        :class="`nxp-card-button-vacancy ${
          isSimilar ? 'primary' : isOpen ? 'company' : ''
        }`"
      >
        Ver descrição
      </button>
      <button
        class="vacancy-card-btn-cancel"
        @click="handleUnsubscribe"
        v-if="displayUnsubscribe && talent_withdrawal === null"
      >
        Desistir do processo seletivo
      </button>
      <button
        v-else-if="displayUnsubscribe && vacancy_status === 1"
        @click="handleReApply"
        class="nxp-card-button-vacancy primary"
      >
        Candidatar-se Novamente
      </button>
    </div>
    <vs-popup
      title="Desistindo do processo seletivo"
      :active.sync="popupActive"
    >
      <vs-row>
        <vs-col vs-type="flex" vs-align="center" vs-justify="end" vs-w="12">
          <p>
            Tem certeza que você quer desistir do processo seletivo para a vaga
            <b>{{ title.substring(0, 30) + "..." }}</b
            >. <br />

            <strong>Atenção!</strong> esta ação é permanente e não poderá ser
            desfeita. <br />
            Poderia nos contar porque está fazendo isto?
          </p>
        </vs-col>
        <div style="width: 100%; height: 40px">
          <v-select
            class="vacancy-card-select"
            name="unsubscribe"
            v-model="unSubscribe"
            :options="unsubscribeOptions"
            placeholder="Selecione um motivo"
          >
          </v-select>
        </div>
        <vs-col
          class="vacancy-cancel-actions"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <vs-button
            class="mx-1"
            @click="popupActive = false"
            color="dark"
            type="flat"
          >
            Continuar no processo seletivo
          </vs-button>
          <vs-button
            class="mx-1"
            @click="doApplication"
            color="danger"
            type="filled"
          >
            Desistir
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import Bolt from "../icons/Bolt.vue";
import SkeletonLoader from "../skeleton-loader/SkeletonLoader.vue";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    showPreInterviewButton: {
      type: Boolean,
      required: false,
    },
    displayUnsubscribe: {
      type: Boolean,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
    application: {
      type: Object,
      required: false,
    },
    isSimilar: {
      type: Boolean,
      required: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    location: "",
    show_details: false,
    popupActive: false,
    isForms: false,
    unSubscribe: "",
    unsubscribeOptions: [
      "Não quero justificar",
      "Recebi uma outra proposta",
      "Me candidatei na vaga errada",
      "Tive problemas no processo seletivo",
      "Outro",
    ],
  }),
  computed: {
    ...mapState("company", ["company"]),
    formattedRemuneration() {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(this.vacancy.remuneration);
    },

    preInterviewWasStartedButNotFinished() {
      const preInterviewStatus =
        this.vacancy &&
        this.vacancy.applications &&
        this.vacancy.applications.length > 0 &&
        this.vacancy.applications[0].pre_interview &&
        this.vacancy.applications[0].pre_interview.status === "processing";

      return preInterviewStatus;
    },

    hasPreInterview() {
      const hasPreInterview =
        this.vacancy &&
        this.vacancy.applications &&
        this.vacancy.applications.length > 0 &&
        this.vacancy.applications[0].pre_interview !== null;

      return hasPreInterview;
    },

    color() {
      if (this.vacancy_status === 1)
        return this.company.base_hexcolor || "#1551b1";
      else return "#cecece";
    },

    colorSoft() {
      if (this.vacancy_status === 1)
        return this.company.base_hexcolor + "2E" || "#1551b12E";
      else return "#cececeCD";
    },

    title() {
      return this.vacancy !== undefined && this.vacancy.hasOwnProperty("title")
        ? this.vacancy.title
        : "";
    },

    vacancy_status() {
      if (
        this.vacancy !== undefined &&
        this.vacancy.hasOwnProperty("vacancy_status_id")
      ) {
        return this.vacancy.vacancy_status_id;
      }
      return this.vacancy !== undefined && this.vacancy.hasOwnProperty("status")
        ? this.vacancy.status.id
        : "";
    },

    description() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("description")
        ? this.vacancy.description
        : "";
    },

    vacancy_published_at() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("published_at")
        ? this.vacancy.published_at
        : "";
    },

    vacancy_company_name() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("company") &&
        this.vacancy.company.hasOwnProperty("name")
        ? this.vacancy.company.name
        : null;
    },

    talent_applicated_at() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("applications") &&
        this.vacancy.applications.length > 0
        ? formatDistanceToNow(
            new Date(this.vacancy.applications[0].created_at),
            { locale: ptBR, addSuffix: true }
          )
        : "";
    },

    talent_withdrawal() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("applications") &&
        this.vacancy.applications.length > 0
        ? this.vacancy.applications[0].application_withdrawal_id
        : null;
    },

    showLocation() {
      return (
        this.vacancy &&
        this.vacancy.show_location &&
        this.vacancy.show_location == 1
      );
    },
  },
  methods: {
    handleRedirectToApplicationProcess() {
      const { params } = this.$router.history.current;

      this.$router.push({
        name: "application-process",
        params: {
          ...params,
          step_id: this.step_id,
          vacancy_id: this.vacancy.id,
        },
      });
    },
    async doApplication() {
      try {
        this.popupActive = false;
        this.$vs.loading();

        const body = {
          application_id: this.vacancy.applications[0].id,
          description: this.unSubscribe,
        };

        const response = await this.$http.post(
          `/api/v2/applications-withdrawal/`,
          body
        );

        if (response.status == 200) {
          this.$vs.notify({
            title: "Candidatura removida com sucesso!",
            text: response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          // PostHog: application_withdrawn (confirmada)
          (async () => {
            try {
              const { trackEvent } = await import("@/services/posthog");
              trackEvent("application_withdrawn", {
                vacancy_id: this.vacancy.id,
                application_id: this.vacancy.applications[0].id,
                reason: this.unSubscribe || null,
              });
            } catch (_) {}
          })();
        }
        this.$vs.loading.close();
        if (this.isForms) {
          this.handleRedirectToApplicationProcess();
        } else {
          this.$router.back();
        }
      } catch (error) {
        this.popupActive = false;
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao Remover candidatura",
          text: "Falha ao realizar o procedimento contate a nossa equipe de suporte",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },

    handleUnsubscribe() {
      this.popupActive = true;
    },

    async handleReApply() {
      try {
        this.$vs.loading();

        const response = await this.$http.put(
          `/api/v1/applications/${this.vacancy.applications[0].id}/restore`
        );

        if (response.status == 200) {
          this.$vs.notify({
            title: "Você se candidatou novamente à vaga",
            text: response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        }
        this.$vs.loading.close();
        this.handleRedirectToApplicationProcess();
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao candidatar-se novamente à vaga",
          text: "Falha ao realizar o procedimento tente novamente mais tarde",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
      window.woopra.track("reapply-click", {
        vacancy_id: this.vacancy.id,
        application_id: this.vacancy.applications[0].id,
      });
    },

    handleTrainForInterview() {
      const token = this.$store.getters["auth/token"];
      const interviewLink = `${process.env.VUE_APP_TRAINING_INTERVIEW_URL}/interview/${this.vacancy.applications[0].talent_uuid}?app_id=${this.vacancy.applications[0].id}&token=${token}`;
      window.woopra.track("interview-training-click", {
        app_id: this.vacancy.applications[0].id,
        talent_uuid: this.vacancy.applications[0].talent_uuid,
        vacancy_id: this.vacancy.id,
      });
      window.open(interviewLink, "_blank");
    },

    trackSimilarVacancyClick(vacancy) {
      window.woopra.track("similar-detail-click", {
        vacancy,
      });
    },
  },
  components: {
    "v-select": vSelect,
    Bolt,
    SkeletonLoader,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/vacancycard.scss";
</style>
